import { Nullable } from 'legacy/lut/classes/models/utils'
import { FC } from 'react'
import { useSelector } from 'react-redux'

import { selectPublishingMode } from 'core/store/selectors/selectPublishingMode'
import { FieldLabel } from 'partner360/components/fieldLabel/FieldLabel'

import { getTranslationByPartnerAccess } from '../../../helpers/getTranslationByPartnerAccess'

import { OneKeyDirectionEditMode } from './components/oneKeyDirectionEditMode/OneKeyDirectionEditMode'
import { OneKeyDirectionReadMode } from './components/oneKeyDirectionReadMode/OneKeyDirectionReadMode'

interface IOneKeyDirectionProps {
  isRequiredForCompleteness: boolean
  oneKeyDirection: Nullable<string>
  isRetail?: boolean
}

export const OneKeyDirection: FC<IOneKeyDirectionProps> = ({
  isRetail,
  isRequiredForCompleteness,
  oneKeyDirection,
}) => {
  const isEditMode = useSelector(selectPublishingMode)

  return (
    <div>
      <FieldLabel
        labelTranslation={getTranslationByPartnerAccess('partnerbasicinfo-year-achievement', {
          isRetail,
        })}
      />
      {!isEditMode && <OneKeyDirectionReadMode oneKeyDirection={oneKeyDirection} />}
      {isEditMode && (
        <OneKeyDirectionEditMode
          isRequiredForCompleteness={isRequiredForCompleteness}
          oneKeyDirection={oneKeyDirection}
        />
      )}
    </div>
  )
}
